import React, { useEffect } from "react";
import { SocialShare, StoryElement } from "@quintype/components";
import { object, bool, number } from "prop-types";
import get from "lodash/get";

import Dailymotion from "react-dailymotion";
import YouTube from "react-youtube";
import getYouTubeID from "get-youtube-id";

import Headline from "../../../atoms/headline";
import CardImage from "../../../atoms/cardimage";
import SectionAndTimeStamp from "../../../molecules/section-and-timestamp";
import SocialShareLinks from "../../../molecules/social-share";

import { addNoFollowAttribute } from "../../../helper/add-no-follow-attribute";

import "./video-header-block.m.css";

const DmPlayer = ({ element }) => {
  const videoId = get(element, ["metadata", "video-id"], null);

  return (
    <div>
      <Dailymotion video={videoId} autoplay />
    </div>
  );
};

DmPlayer.propTypes = {
  element: object,
};

const YoutubePlayer = ({ element, index }) => {
  const options = {
    playerVars: {
      autoplay: 1,
      mute: index ? 1 : 0,
    },
  };

  const onReady = (e) => {
    e.target.playVideo();
  };

  return <YouTube videoId={getYouTubeID(element.url)} opts={options} onReady={onReady} />;
};

YoutubePlayer.propTypes = {
  element: object,
  index: number,
};

const VideoHeaderBlock = ({ story, primaryVideo, isReview, index }) => {
  useEffect(() => {
    addNoFollowAttribute();
  }, []);

  let renderTemplates = {};

  if (primaryVideo && primaryVideo.subtype === "dailymotion-video") {
    renderTemplates = { "dailymotion-video": DmPlayer };
  } else if (primaryVideo && primaryVideo.type === "youtube-video") {
    renderTemplates = { "youtube-video": YoutubePlayer };
  }

  return (
    <div styleName="wrapper">
      <div styleName="story-video">
        {primaryVideo && (
          <StoryElement element={primaryVideo} story={story} renderTemplates={renderTemplates} index={index} />
        )}
        {isReview && (
          <CardImage
            story={story}
            defaultWidth={710}
            aspectRatio={[16, 9]}
            imageType="image16x9"
            showImageCaption={true}
            eager={true}
          />
        )}
      </div>
      <div styleName="video-text">
        <Headline text={story.headline} headerType={7} />
        {story.summary && <p styleName="summary">{story.summary}</p>}
        <SectionAndTimeStamp story={story} />
        <SocialShare
          template={SocialShareLinks}
          storyId={story.id}
          title={story.headline}
          url={story.slug}
          color="#fff"
        />
      </div>
    </div>
  );
};

VideoHeaderBlock.propTypes = {
  story: object,
  primaryVideo: object,
  isReview: bool,
  index: number,
};

export default VideoHeaderBlock;
